// @ts-nocheck

import { colors } from '@lmc/common/constants'

const EmptyState = (props) => {
  const { title, imageSrc, children } = props

  return (
    <div style={styles.emptyStateWrapper}>
      <img alt="" src={imageSrc} style={styles.emptyStateImg} />
      <h2 style={styles.emptyStateTitle}>{title}</h2>
      <div style={styles.emptyStateBody}>{children}</div>
    </div>
  )
}

const styles = {
  emptyStateImg: {
    margin: '55px 0px 30px',
    maxHeight: 165,
  },
  emptyStateBody: {
    lineHeight: '22px',
    marginBottom: 35,
    textAlign: 'center',
  },
  emptyStateTitle: {
    lineHeight: '36px',
  },
  emptyStateWrapper: {
    alignItems: 'center',
    background: colors.white,
    borderRadius: 15,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}

export default EmptyState
